<script>
import { BMediaBody } from "bootstrap-vue";

export default {
  extends: BMediaBody
};
</script>